import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CancelIcon from '@mui/icons-material/Cancel';

const ScreenContainer = (props) => {
  const { steps, activeStep, stepType } = props;
  let stepperClassName = "customStepper";

  if(stepType==="completed")
    stepperClassName='customStepper completedForStepper';
  else if(stepType==="canceled")
    stepperClassName='customStepper canceledForStepper';

  return (
    <Stepper activeStep={activeStep} alternativeLabel className={stepperClassName}>
    {steps.map((label) => (
      <Step key={label} className='customStepperStep'>
        <StepLabel StepIconComponent={stepType==="canceled"&&CancelIcon} className='customStepperStepLabel'>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
  );
};

export default ScreenContainer;
